import { CAMPAIGNv3 } from './mediaPlanning';
import { ApiResponse } from './types';
import { ComparedPlan } from '../../../store/planStore';
import { postData } from './utils';

export const getMultiplePlans = async (ids: string[]) => {
  return postData<ApiResponse<ComparedPlan[]>>(
    `/${CAMPAIGNv3}/media-plans/compare`,
    { ids }
  );
};
